import { TextField } from "@goodgamestudios/createjs-utilities";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Model } from "../../../../model/Poker2Model";
import { TeaserTextsVO } from "./TeaserTextsVO";
import { TeaserVO } from "./TeaserVO";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;

export class AbstractTeaser extends Container {
    protected _featureId: number = 0;

    protected _teaserMc: MovieClip;
    protected _btnClose: MovieClip;

    protected onClick: Function;
    protected _textContainer: MovieClip;
    protected _teaserVO: TeaserVO;

    constructor(featureId: number, teaserMc: MovieClip, teaserVO: TeaserVO) {
        super();

        this._featureId = featureId;
        this._teaserMc = teaserMc;
        this._teaserVO = teaserVO;

        this.build();
    }

    private build(): void {
        this.addChild(this._teaserMc);

        // define references
        this._btnClose = this._teaserMc.btn_close;
        this._textContainer = this._teaserMc.mc_textcontainer;

        // call hook
        this.buildHook();
    }

    protected fillTextContainerFields(): void {
        var textChildren: number = int(this._textContainer.numChildren);

        var tempTextField: TextField;

        for (var i: number = 0; i < textChildren; i++) {
            tempTextField = this._textContainer["txt_" + i];
            tempTextField.text = Poker2Model.languageData.getTextById("feature_" + this._featureId + "_text_" + i);
        }
    }

    protected buildHook(): void {
        // override in your child class if needed
    }

    public fillTexts(vo: TeaserTextsVO): void {
        this.fillTextContainerFields();
    }

    public fillButtonLabels(vo: TeaserTextsVO = null): void {
        // override
    }
}
classImplementsInterfaces(AbstractTeaser, "Container");
